import { render, staticRenderFns } from "./SectionSubInfo.vue?vue&type=template&id=250a3398&scoped=true&"
import script from "./SectionSubInfo.vue?vue&type=script&lang=js&"
export * from "./SectionSubInfo.vue?vue&type=script&lang=js&"
import style0 from "./SectionSubInfo.vue?vue&type=style&index=0&id=250a3398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250a3398",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
